<template>
	<v-bottom-navigation grow :bg-color="color" :height="56 + safeArea.bottom" class="nav-bottom-bar" :model-value="selected">
		<v-btn v-for="key in panelKeys" :key="key" :value="key" @click="emit('toggle', key)">
			<v-badge :model-value="counts[key] > 0" :content="counts[key]" color="secondary">
				<v-icon>{{ NAV_PANELS[key].icon }}</v-icon>
			</v-badge>
			<span>{{ t(NAV_PANELS[key].labelKey) }}</span>
		</v-btn>

		<v-btn value="connection" color="success" :class="{ 'nav-bottom-bar__offline': !nav.online }" @click="emit('action', 'toggleOffline')">
			<v-icon>{{ nav.online ? 'wifi' : 'wifi_off' }}</v-icon>
			<span>{{ t(nav.online ? 'Online' : 'Offline') }}</span>
		</v-btn>

		<v-btn v-if="nav.isLocalhost" value="purge" @click="emit('action', 'clearLegacyAppCache')">
			<v-icon>delete_sweep</v-icon>
			<span>{{ t('Purge') }}</span>
		</v-btn>

		<v-btn value="menu" @click="emit('toggle', 'menu')">
			<v-badge :model-value="nav.updateReady || nav.extensionUpdate" dot color="secondary">
				<v-icon>menu</v-icon>
			</v-badge>
			<span>{{ t('Menus') }}</span>
		</v-btn>
	</v-bottom-navigation>
</template>

<script setup>
import { computed } from 'vue';
import { NAV_PANELS, MOBILE_PANEL_ORDER } from './navPanels';
import { useAppChrome } from '@/composables/useAppChrome';
import { useTranslator } from '@/composables/useTranslator';

const props = defineProps({
	open: { type: String, default: null },
});
const emit = defineEmits(['toggle', 'action']);

const t = useTranslator();
const { nav, safeArea, counts, panels, color } = useAppChrome();

const panelKeys = computed(() => MOBILE_PANEL_ORDER.filter((key) => panels.value.includes(key)));
const selected = computed(() => props.open ?? null);
</script>
